export const isString = value => typeof value === "string";

export const isUnique = () => {
	const processed = new Set();

	return value => {
		if (processed.has(value)) return false;
		processed.add(value);
		return true;
	};
};

export const isNotEmpty = value => Boolean(value);
